const AngularInstructionJs=()=>{
  return(
    <div className="instructions">
<p>2. Copy the provided code and paste it into the same component JS file where you previously pasted it.</p>
    </div>
  )
}
export default AngularInstructionJs